import * as React from "react";
import { connect } from "react-redux";
import FocusFileBrowser from "../components/FileBrowser/FocusFileBrowser";
import { FileBrowserFilesContext } from "../contexts";
import { withContext } from "../contexts/withContext";
import { Dialog } from "../components/externals";
import { ItemStatus } from "../entities";
import { Loading } from "../components/Loading";
import { Error } from "../components/Error";
const _FileBrowserFileManager = (props) => {
    let browser;
    switch (props.headerStatus) {
        case ItemStatus.ERROR:
            browser = (React.createElement("div", null,
                React.createElement("br", null),
                React.createElement(Error, { message: props.headerError })));
            break;
        case ItemStatus.READY:
            let header = typeof props.header === "undefined"
                ? { locations: [], extensions: [] }
                : props.header;
            let elements = typeof props.elements === "undefined" ||
                Object.keys(props.elements).length == 0
                ? { collection: { items: [] } }
                : props.elements;
            browser = (React.createElement(FocusFileBrowser, { isDialogOpen: props.isDialogOpen, currentPath: props.currentPath, rootPaths: header.locations, extensions: header.extensions, elements: elements.collection.items, elementsStatus: props.elementsStatus, elementsError: props.elementsError, clickedLocation: props.selectedLocation, onAccept: props.onAccept, onCancel: props.onCancel, onClickedLocation: props.onClickedLocation, isReadOnly: props.isReadOnly }));
            break;
        default:
            browser = (React.createElement("div", null,
                React.createElement("br", null),
                React.createElement(Loading, null)));
            break;
    }
    return (React.createElement(Dialog, { className: "filebrowser-dialog", icon: "folder-open", title: "File Browser", isOpen: props.isDialogOpen, onClose: props.onCancel }, browser));
};
const mapStateToProps = (state, { __filebrowseritems, header, selectedLocation }) => {
    let elementsFetched = { collection: { items: [] } };
    let elementsError = "";
    let elementsStatus = ItemStatus.PENDING;
    let i = typeof selectedLocation !== "undefined" && selectedLocation >= 0
        ? selectedLocation
        : 0;
    if (typeof header !== "undefined" &&
        typeof header["locations"] !== "undefined" &&
        header["locations"].length != 0) {
        elementsFetched = __filebrowseritems.selectors.getItem(state.filebrowserfiles, { relLocation: header["locations"][i].relativeLocation });
        elementsStatus = __filebrowseritems.selectors.getStatus(state.filebrowserfiles, { relLocation: header["locations"][i].relativeLocation });
        elementsError = __filebrowseritems.selectors.getItemError(state.filebrowserfiles, { relLocation: header["locations"][i].relativeLocation });
    }
    return {
        elements: elementsFetched,
        elementsError,
        elementsStatus,
    };
};
const Connected = connect(mapStateToProps)(_FileBrowserFileManager);
const contextConfig = {
    __filebrowseritems: FileBrowserFilesContext,
};
export const FileBrowserFileManager = withContext(contextConfig)(Connected);
//# sourceMappingURL=FileBrowserFileManager.js.map